import "./common.js";
import "../i18n.js";
import "../portico/header.js";
import "../../styles/portico/portico-styles.scss";
